/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsV1SweepTargetEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_V1_SWEEP_TARGET_EVENT_ENTITY_NAME = 'ixc.sweeps.v1.SweepTargetEvent';
export const ixcSweepsV1SweepTargetEventEntity = new schema.Entity<IxcSweepsV1SweepTargetEvent>(IXC_SWEEPS_V1_SWEEP_TARGET_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsV1SweepTargetEvent) => `${entity.metadata?.eventId}` });

